import React from 'react'

import { GlgModal, GlgProgressBar, GlgButton } from 'Shared/components'

import useSessionStatusModal from '../../hooks/useSessionStatusModal'
import useSessionStatusData from '../../hooks/useSessionStatusData'
import SessionStatsChips from './SessionStatsChips'
import SessionStatusSearch from './SessionStatusSearch'
import SessionStatusTable from './SessionStatusTable'

const SessionStatusModal = () => {
  const { shouldDisplayModal, closeModal } = useSessionStatusModal()
  const { currentSession, totalJobsCount, processedJobsCount, percentage } = useSessionStatusData()

  return (<>
    { shouldDisplayModal ?
      <GlgModal contentClassName={'cls-status-modal'}>
          <span className={'modal-title-container'}>
            <span className={'title'}>{window.I18n.t('clone_leagues_sessions.general.cloning_session')}</span>
            <span className={'close-button'} onClick={closeModal}>X</span>
          </span>
          <div className={'modal-content-container'}>

            <div className={'progress-container'}>
              <span className={'progress-title-row'}>
                <span className={'progress-title'}>{currentSession?.name}</span>
              </span>
              <GlgProgressBar
                percentage={percentage}
                barClassName={'progress-bar'}
                fillClassName={totalJobsCount === processedJobsCount ? 'progress-fill-completed' : 'progress-fill'}
              />
              <span className={'progress-extras-container'}>
                <span className={totalJobsCount === processedJobsCount ? 'progress-extras-text completed' : 'progress-extras-text'}>
                  {totalJobsCount === processedJobsCount ?
                    <>{window.I18n.t('clone_leagues_sessions.general.completed')}
                      <i className="fa-solid fa-circle-check completed-icon"/></> :
                    `${window.I18n.t('clone_leagues_sessions.general.cloning')}...`
                  }
                </span>
                {totalJobsCount !== processedJobsCount &&
                  <span className={'progress-extras-text'}>
                    {processedJobsCount}/{totalJobsCount} {window.I18n.t('clone_leagues_sessions.status.completed')}
                  </span>
                }
              </span>
            </div>
            <SessionStatsChips />
            <SessionStatusSearch />
            <SessionStatusTable />
          </div>
          <div className={'modal-footer'}>
            <GlgButton text={window.I18n.t('buttons.done')} onClick={closeModal} />
          </div>
      </GlgModal>
      : null
    }
  </>)
}

export default SessionStatusModal
